import React from "react";
import { Phone, MessageCircle, MapPin, Mail, Clock, Truck } from "lucide-react";
import { BRAND, telHref, waHref } from "../lib/site";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-bold uppercase tracking-wider">
            Contact Us
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
            Hum se <span className="text-orange-600">judiye</span> aaj hi
          </h2>
          <p className="mt-4 text-slate-600">
            Office aaiye, call kijiye ya WhatsApp pe message — hum 24/7 available hain.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {[
            {
              icon: Phone,
              title: "Call Us",
              value: BRAND.phone,
              cta: "Call Now",
              href: telHref,
              color: "from-blue-700 to-blue-900",
              testid: "contact-call",
            },
            {
              icon: MessageCircle,
              title: "WhatsApp",
              value: BRAND.whatsapp,
              cta: "Chat Now",
              href: waHref(),
              color: "from-[#25D366] to-emerald-700",
              testid: "contact-whatsapp",
            },
            {
              icon: MapPin,
              title: "Office Address",
              value: BRAND.address,
              cta: "Get Directions",
              href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BRAND.address)}`,
              color: "from-orange-500 to-red-600",
              testid: "contact-address",
            },
          ].map((c, idx) => {
            const Icon = c.icon;
            return (
              <a
                key={c.title}
                href={c.href}
                target={c.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                data-testid={c.testid}
                className="group rounded-2xl bg-white border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-xl transition-all"
              >
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${c.color} text-white grid place-items-center shadow-md group-hover:scale-110 transition`}>
                  <Icon size={24} />
                </div>
                <h3 className="mt-4 text-lg font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.value}</p>
                <span className="mt-4 inline-block text-sm font-semibold text-orange-600 group-hover:underline">
                  {c.cta} →
                </span>
              </a>
            );
          })}
        </div>

        <div className="mt-8 grid md:grid-cols-3 gap-4">
          <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl px-4 py-3">
            <Clock className="text-blue-700" size={20} />
            <div>
              <div className="text-sm font-bold text-slate-900">24/7 Available</div>
              <div className="text-xs text-slate-500">Reasonable price, prompt response</div>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl px-4 py-3">
            <Truck className="text-orange-600" size={20} />
            <div>
              <div className="text-sm font-bold text-slate-900">Delhi NCR Wide</div>
              <div className="text-xs text-slate-500">Delhi · Noida · Gurgaon · Faridabad</div>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl px-4 py-3">
            <Mail className="text-red-600" size={20} />
            <div>
              <div className="text-sm font-bold text-slate-900">Email</div>
              <div className="text-xs text-slate-500">{BRAND.email}</div>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-10 rounded-2xl overflow-hidden border border-slate-200 shadow-md">
          <iframe
            title="A Seven Packers and Movers Map"
            data-testid="contact-map"
            src={`https://www.google.com/maps?q=${encodeURIComponent(BRAND.address)}&output=embed`}
            width="100%"
            height="360"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
